import { __assign, __rest } from "tslib";
import React from 'react';
import { logInDev, useThemeProps } from '../../foundation';
import { RcBox } from '../Box';
import { RcDefaultLoadingWithDelay } from './styles';
/**
 * Provide a wrapper to wrap component with loading mask
 *
 * ### when `keepVisible = false` that children must be one valid html **element**, otherwise that style could not set correctly
 */
var RcLoading = function (inProps) {
    var props = useThemeProps({ props: inProps, name: 'RcLoading' });
    var _a = props.LoadingComponent, LoadingComponent = _a === void 0 ? RcDefaultLoadingWithDelay : _a, _b = props.keepVisible, keepVisible = _b === void 0 ? true : _b, _c = props.keepMounted, keepMounted = _c === void 0 ? true : _c, loading = props.loading, _d = props.LoadingProps, _e = _d === void 0 ? {} : _d, _f = _e.delay, delay = _f === void 0 ? 0 : _f, _g = _e.backgroundType, backgroundType = _g === void 0 ? 'mask' : _g, _h = _e.size, size = _h === void 0 ? 42 : _h, LoadingProps = __rest(_e, ["delay", "backgroundType", "size"]), children = props.children;
    var childrenWhenLoading = !keepMounted && loading ? null : children;
    var getCloneNode = function () {
        if (childrenWhenLoading &&
            React.isValidElement(childrenWhenLoading) &&
            childrenWhenLoading.type !== React.Fragment) {
            return (React.createElement(RcBox, { clone: true, display: "none" }, childrenWhenLoading));
        }
        if (process.env.NODE_ENV !== 'production') {
            logInDev({
                component: 'RcLoading',
                message: 'please confirm your children is a valid html element to set style, when you use `keepVisible=false`',
            });
        }
        return childrenWhenLoading;
    };
    return (React.createElement(React.Fragment, null,
        loading && (React.createElement(LoadingComponent, __assign({ delay: delay, backgroundType: backgroundType, size: size }, LoadingProps))),
        keepVisible || !loading ? childrenWhenLoading : getCloneNode()));
};
export { RcLoading };
